import AccountSettingsIcon from "assets/svg/AccountSettingsIcon";
import DashboardIcon from "assets/svg/DashboardIcon";
import LogoutIcon from "assets/svg/LogoutIcon";
import SettingsIcon from "assets/svg/SettingsIcon";
import TransactionIcon from "assets/svg/TransactionIcon";
import WalletIcon from "assets/svg/WalletIcon";

interface NavItem {
  label: string;
  path: string;
  icon?: React.ReactNode;
  children?: NavItem[];
}

export const navigationData: NavItem[] = [
  {
    label: "Dashboard",
    path: "/admin/dashboard",
    icon: <DashboardIcon />,
  },
  {
    label: "User Wallets",
    path: "/admin/wallet",
    icon: <WalletIcon />,
  },
  {
    label: "Transactions",
    path: "/admin/transactions",
    icon: <TransactionIcon />,
  },
  {
    label: "Users",
    path: "/admin/users",
    icon: <AccountSettingsIcon />,
  },
  {
    label: "Settings",
    path: "/admin/settings",
    icon: <SettingsIcon />,
  },
  {
    label: "Logout",
    path: "/admin/logout",
    icon: <LogoutIcon width={24} height={24} />,
  },
];
